export default __webpack_public_path__ + "static/media/news-12.26cb52c1.jpg";